const activeEventUrl = 'sales-event/v1'

const baseConfig = {
    apiKey: 'blt7d4c4f4a1bf5a819',
    clientId: '66408e5bca6b4a59b2c7fc62b8c00a9f',
    url: 'https://graphql.contentstack.com'
};
  
const config = {
    dev: {
        ...baseConfig,
        accessToken: 'cs74599c107573ea7f6c7a1413',
        env: 'public-dev',
        graphqlUrl: 'https://apis.dev.nuskin.com/product/graphql',
        activeEventUrl: `https://devapi.cloud.nuskin.com/${activeEventUrl}`
    },
    prod: {
        ...baseConfig,
        accessToken: 'cs7029c5e32f0e99978efc683d',
        env: 'public-prod',
        graphqlUrl: 'https://apis.nuskin.com/product/graphql',
        activeEventUrl: `https://api.cloud.nuskin.com/${activeEventUrl}`      
    },
    test: {
        ...baseConfig,
        accessToken: 'cs67e9fdd60eb15c301add40ea',
        env: 'public-test',
        graphqlUrl: 'https://apis.test.nuskin.com/product/graphql',
        activeEventUrl: `https://testapi.cloud.nuskin.com/${activeEventUrl}`
    }
};
  
/**
   * getConfig returns config.
   *
   * @param {string} env
   * @return {{accessToken: string; apiKey: string; env: string; graphqlUrl: string; url: string; }} 
   */
function getConfig(env) {
    if (config[env] === undefined) {
        return {};
    }
  
    return config[env];
}
  
module.exports = {
    getConfig
}